import { EntryTypeItemPresentationData, Optional } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export class EntryTypeItemPresentationList extends SimpleList<EntryTypeItemPresentationData> {
    protected readonly identifiableFieldName: string = 'itemId';

    public getByItemId(itemId: string): Optional<EntryTypeItemPresentationData> {
        return this.values.find(value => itemId === value.itemId);
    }
}
